import {
  DEFAULT_EXTRA_FIELD_DISPLAY,
  normalizeExtraFieldDisplay,
} from "../data/extraFieldTypes";

export const fetchExtraFieldSetting = async (api, entityType) => {
  try {
    const result = await api.getExtraFieldSettingByEntityType(entityType);
    return normalizeExtraFieldDisplay({
      entityType,
      ...(result ?? {}),
    });
  } catch (error) {
    return { ...DEFAULT_EXTRA_FIELD_DISPLAY, entityType };
  }
};

export const saveExtraFieldSetting = async (api, entityType, values) => {
  const display = normalizeExtraFieldDisplay(values);
  return api.upsertExtraFieldSettingByEntityType({
    entityType,
    ...display,
  });
};
